<template>
  <div class="main">


    <!-- Delivery Items modal section -->
    <b-modal v-model="modalOpen" title="Select Delivery Items" centered size="xl">

      <div class="px-3 px-md-5"> <!-- Adjust padding for responsiveness -->
        <b-col cols="12" class="d-flex justify-content-end mb-2" style="position: relative; z-index: 1;">
          <b-button variant="outline-danger" size="sm" @click="clearFilters">
            Clear Filters
          </b-button>
        </b-col>
        <b-table striped hover responsive="xl" :items="filteredDeliveryItems" :fields="deliveryItemFieldsModal">

          <template #head(invoiceNo)="scope">
            <div class="d-flex flex-column">
              <span>Invoice Number</span>
              <b-form-input v-model="filters.invoiceNo" placeholder="Search Invoice No" size="sm"
                @input="currentPage = 1" />
            </div>
          </template>

          <template #head(itemId)="scope">
            <div class="d-flex flex-column">
              <span>Product Name</span>
              <b-form-input v-model="filters.itemId" placeholder="Search Product Name" size="sm"
                @input="currentPage = 1" />
            </div>
          </template>

          <template #head(note)="scope">
            <div class="d-flex flex-column">
              <span>Description</span>
              <b-form-input v-model="filters.note" placeholder="Search Description" size="sm"
                @input="currentPage = 1" />
            </div>
          </template>

          <template #head(quantity)="scope">
            <div class="d-flex flex-column">
              <span>Quantity</span>
              <b-form-input v-model="filters.quantity" placeholder="Search Quantity" size="sm" type="number"
                @input="currentPage = 1" />
            </div>
          </template>

          <template #cell(invoiceNo)="data">
            {{ data.item.invoice.invoiceNo }}
          </template>

          <template #cell(itemId)="data">
            <span> {{ getProductName(data.item.itemId) }}</span>
          </template>

          <template #cell(description)="data">
            {{ data.item.description }}
          </template>

          <template #cell(quantity)="data">
            {{ data.item.quantity }}

          </template>

          <template #cell(check)="row">
            <b-form-checkbox v-model="row.item.selected" />
          </template>
        </b-table>
      </div>
      <template #modal-footer>
        <b-button @click="saveChanges" variant="primary">Save Changes</b-button>
      </template>
    </b-modal>

    <!-- Delivery Items Section -->
    <b-card class="mt-3">
      <b-card-header>
        <div class="d-flex justify-content-between align-items-center">
          <div class="mr-5">Selected Delivery Item Details</div>
          <!-- <b-button @click="toggleModal" variant="primary">Select</b-button> -->
        </div>
      </b-card-header>
      <b-card-body>
        <!-- Table for delivery items, showing selected items -->
        <b-table striped hover responsive :items="selectedItemsWithStatus" :fields="selectedItemFields">
          <!-- <template #cell(invoiceNo)="data">
            {{ data.item.invoiceNo }}
          </template> -->
          <template #cell(productID)="data">
            {{ getProductName(data.item.productID) }}
          </template>
          <template #cell(note)="data">
            {{ data.item.deliveryNote.note }}
          </template>
          <template #cell(quantity)="data">
            {{ data.item.deliveryNote.quantity }}
          </template>
          <template #cell(status)="row">
            <div class="d-flex align-items-center" 
           >

              <b-badge :variant="getStatusColor(row.item.status)">{{
                row.item.status
              }}</b-badge>

            </div>
          
          </template>
          <!-- <template #cell(note)="data">
                {{ data.item.deliveryNote.note }}
          </template>
          <template #cell(quantity)="data">
                {{ data.item.deliveryNote.quantity }}
          </template> -->
          <template #cell(actions)="data">
            <b-dropdown variant="link" toggle-class="p-0" no-caret class="m-1">
                  <template #button-content>
                    <feather-icon icon="MoreVerticalIcon" size="16" class="align-middle text-body" />
                  </template>
                  <b-dropdown-item @click="confirmDeleteDelivery(data.item)">
                    <feather-icon icon="TrashIcon" />
                    <span class="align-middle ml-1">Delete</span>
                  </b-dropdown-item>
            </b-dropdown>
          </template>
          <template #cell(check)="row">
  <b-form-checkbox v-model="row.item.selected" />
</template>
        </b-table>
      </b-card-body>
    </b-card>

    <b-card>
      <b-card-body>

        <b-row>
          <b-col md="6" cols="6" class="my-md-1">
            <b-form @submit.prevent="SubmitDelivery">
              <b-form-group label="Vehicle" label-for="vehicle">

                <b-form-select id="vehicleId" v-model="deliveryid.vehicleID" :options="vehicleOptions" required />
              </b-form-group>
              <b-form-group label="Driver" label-for="driver">
                <b-form-select id="driverId" v-model="deliveryid.driverID" :options="driverOptions" required />
              </b-form-group>
              <b-form-group label="Pickup Location" label-for="pickUpLocation">
                <b-form-select id="pickUpLocation" v-model="deliveryid.pickUpLocation" :options="locationOptions"
                  required />
              </b-form-group>
              <b-form-group label="Dropoff Location" label-for="dropOffLocation">
                <b-form-select id="dropOffLocation" v-model="deliveryid.dropOffLocation" :options="locationOptions"
                  required />
              </b-form-group>
            
              <b-form-group label="Delivery Date" label-for="deliveryDate">
                <b-form-datepicker id="deliveryDate" v-model="deliveryid.deliveryDate" :min="currentDate" required />
              </b-form-group>
              <b-form-group label="Delivery Status" label-for="deliveryStatus">
                <b-form-select id="deliveryStatus" v-model="deliveryid.deliveryStatus" :options="deliveryStatusOptions"
                  required />
              </b-form-group>
              <b-form-group label="Notes" label-for="notes">
                <b-form-textarea id="notes" v-model="deliveryid.note" />
              </b-form-group>
              <CustomFieldsDetails :AdditionalFields="deliveryid.additionalFields" :ModuleReference="'Delivery'"
                @onchange="additionalFieldChanges"></CustomFieldsDetails>
              <!-- <b-button type="submit" variant="primary">Save Changes</b-button> -->
              <button type="button" class="btn btn-primary" block @click="SubmitDelivery()">
                <b-spinner small v-if="loading" class="mx-2" />Save Changes
              </button>
            </b-form>

          </b-col>

          <b-col md="6" cols="6" class="my-md-1">
            <div align="center">
              <b-button variant="primary" v-ripple.400="'rgba(255, 255, 255, 0.15)'" target="_blank"
                :href="`https://www.google.com/maps/dir/?api=1&origin=${encodeURIComponent(deliveryid.pickUpLocation)}&destination=${encodeURIComponent(deliveryid.dropOffLocation)}`">View
                Delivery Route</b-button>
            </div>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BForm,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormTextarea,
  BButton,
  BDropdown,
    BDropdownItem,
  BTable,
  BModal,
  BFormCheckbox,
  BBadge,
  BSpinner,
  BCardHeader,
  BCardBody,
  BFormDatepicker
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import Swal from 'sweetalert2';
import { mapActions, mapGetters } from "vuex";
import CustomFieldsDetails from "@/views/component/CustomFieldsDetails.vue";
import { formatDate } from '@/libs/customFn';
export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BForm,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormTextarea,
    BDropdown,
    BDropdownItem,
    BButton,
    BTable,
    BModal,
    BFormCheckbox,
    BBadge,
    BSpinner,
    BFormDatepicker,
    CustomFieldsDetails
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      id: this.$route.params.id,
      modalOpen: false,
      vehicleID: "",
      driverID: "",
      pickUpLocation: "",
      dropOffLocation: "",
      deliveryDate: "",
      deliveryStatus: "",
      note: "",
      additionalFields: "",
      currentDate: new Date().toISOString().split("T")[0],
      driverOptions: [],
      filters: {
        invoiceNo: "",
        itemId: "",
        note: "",
        quantity: null, // For numeric filtering
      },
      // deliveryItemFields: [
      //   { key: "product", label: "Product", sortable: true },
      //   { key: "quantity", label: "Quantity", sortable: true },
      //   { key: "description", label: "Description", sortable: true },
      // ],
      // deliveryItemFieldsModal: [
      //   { key: "product", label: "Product", sortable: true },
      //   { key: "quantity", label: "Quantity", sortable: true },
      //   { key: "description", label: "Description", sortable: true },
      // ],
      deliveryItemFieldsModal: [
        { key: "invoiceNo", label: "Inv#", sortable: true },
        { key: 'itemId', label: 'Product Name', sortable: true },
        { key: 'note', label: 'Description', sortable: true },
        { key: 'quantity', label: 'Quantity', sortable: true },
        { key: "check", label: "Select" },
      ],
      selectedItemFields: [
        // { key: "invoiceNo", label: "Inv#" },
        { key: 'productID', label: 'Product Name' },
        { key: 'note', label: 'Description' },
        { key: 'quantity', label: 'Quantity' },
        { key: "status", label: "Status", sortable: true },
        { key: 'actions', label: 'Actions' },
      ],
      vehicleOptions: [],
      driverOptions: [],
      // deliveryStatusOptions: ["Pending", "In Transit", "Completed"],
      //SD dont add SCHEDULED & PENDING 
      deliveryStatusOptions: [ "INTRANSIT", "DELIVERED", "CANCELLED", "RETURNED"],
      locationOptions: [
        "16eme Mille",
        "Agalega",
        "Albion",
        "Amitie Gokhoola",
        "Arsenal",
        "Baie Du Cap",
        "Bambous",
        "Bambous Virieux",
        "Bananes",
        "Beau Bassin",
        "Beau Vallon",
        "Bel Air",
        "Bel Ombre",
        "Benares",
        "Black River",
        "Bois Cheri",
        "Bois Des Amourettes",
        "Bon Accueil",
        "Bramsthan",
        "Brisee Verdiere",
        "Britannia",
        "Calebasses",
        "Camp Carol",
        "Camp De Masque",
        "Camp De Masque Pave",
        "Camp Diable",
        "Camp Ithier",
        "Cap Malheureux",
        "Cascavelle",
        "Case Noyale",
        "Central Flacq",
        "Chamarel",
        "Chamouny",
        "Chemin Grenier",
        "Clemencia",
        "Cluny",
        "Congomah",
        "Cottage",
        "Creve Coeur",
        "Curepipe",
        "D'Epinay",
        "Dagotiere",
        "Dubreuil",
        "Eau Coulee",
        "Ebene",
        "Ecroignard",
        "Flic en Flac",
        "Fond du Sac",
        "FOREST - SIDE",
        "G.R.S.E",
        "Goodlands",
        "Grand Bay",
        "Grand Bel Air",
        "Grand Bois",
        "Grand Gaube",
        "Grand Sable",
        "Grande Retraite",
        "Gros Cailloux",
        "L'Avenir",
        "L'Escalier",
        "L'Esperance",
        "L'Esperance Trebuchet",
        "La Flora",
        "La Gaulette",
        "La Laura / Malenga",
        "Lalmatie",
        "Laventure",
        "Le Hochet",
        "Le Morne",
        "Long Mountain",
        "Mahebourg",
        "Mapou",
        "Mare D'Albert",
        "Mare La Chaux",
        "Mare Tabac",
        "Medine Camp de Masque",
        "Melrose",
        "Midlands",
        "Moka",
        "Montagne Blanche",
        "Morc St Andre",
        "New Grove",
        "Notre Dame",
        "Nouvelle Decouverte",
        "Nouvelle France",
        "Old Grand Port",
        "Olivia",
        "Pamplemousses",
        "Petit Bel Air",
        "Petit Raffray",
        "Petite Riviere",
        "Phoenix",
        "Piton",
        "Plaine des Papayes",
        "Plaine Magnien",
        "Pointe aux Piments",
        "Pointe aux Sables",
        "PORT LOUIS",
        "Poste de Flacq",
        "Poudre D'Or Hamlet",
        "Poudre D'Or Village",
        "Providence",
        "Quartier Militaire",
        "QUATRE BORNES",
        "Quatre Cocos",
        "Quatre Soeurs",
        "Queen Victoria",
        "Reduit",
        "Richelieu",
        "Ripailles",
        "Riviere des Anguilles",
        "Riviere des Creoles",
        "Riviere du Poste",
        "Riviere du Rempart",
        "Roche Terre",
        "Roches Noires",
        "Rodrigues - Grand Montagne",
        "Rodrigues - La Ferme",
        "Rodrigues - Mont Lubin",
        "Rodrigues - Port Mathurin",
        "Rodrigues - Riviere Coco",
        "Rose Belle",
        "Rose- Hill",
        "Saint Julien d'Hotman",
        "Saint Julien Village",
        "Saint Pierre",
        "Sebastopol",
        "Souillac",
        "St Hubert",
        "Surinam",
        "Tamarin",
        "Terre Rouge",
        "The Vale",
        "Tombeau Bay",
        "Triolet",
        "Trois Boutiques",
        "Trou aux Biches",
        "Trou D'Eau Douce",
        "Tyack",
        "Union Ducray / St Aubin",
        "Union Park",
        "Vacoas / Floreal",
        "Verdun",
        "Ville Bague",
      ],
      currentDate: new Date().toISOString().split('T')[0],
    };
  },
  computed: {
    filteredDeliveryItems() {
      return this.deliveryItems.filter((item) => {
        const matchesInvoiceNo = !this.filters.invoiceNo || item.invoice.invoiceNo.toLowerCase().includes(this.filters.invoiceNo.toLowerCase());

        const matchesItemId = !this.filters.itemId || this.getProductName(item.itemId).toLowerCase().includes(this.filters.itemId.toLowerCase());

        const matchesDescription = !this.filters.note || (item.note || '').toLowerCase().includes(this.filters.note.toLowerCase());
        const matchesQuantity = !this.filters.quantity ||
          parseFloat(item.quantity) === parseFloat(this.filters.quantity);

        return (
          matchesInvoiceNo &&
          matchesItemId &&
          matchesDescription &&
          matchesQuantity
        );
      });
    },
    ...mapGetters("distributionModule", {
      vehicles: "vehicles",
      loading: "loading",
    }),
    ...mapGetters("deliveriesModule", {
      deliveryid: "deliveryid",
      selectedItemsWithStatus: "item",
      loading: "loading",
    }),

    ...mapGetters("vehicleModule", {
      vehicleId: "vehicleId",
      loading: "loading",
    }),

    ...mapGetters("productModule", {
      products: "product",
      loading: "loading",
    }),
    ...mapGetters("deliveryModule", {
      deliveryItems: "deliverynotes",
      loadingNote: "loading",
    }),

    ...mapGetters("userModule", {
      users: "users",
      usersId: "usersId",
      loading: "loading",
    }),

    formattedDeliveryItems() {
      if (!this.deliveryItems || !Array.isArray(this.deliveryItems)) {
        return [];
      }
      return this.deliveryItems.flatMap(invoice => {
        if (!invoice.invoiceItem && invoice.status !== 'PENDING') {
          return [];
        }
        return invoice.invoiceItem.map(item => ({
          ...item,
          invoiceNo: invoice.invoiceNo,
          //selected: false
        }));

      });
    },

    selectedItems() {
      return this.deliveryItems.filter((item) => item.selected);
    },
    // selectedItemsWithStatus() {
    //   return this.selectedItems.map((item) => {
    //     return {
    //       ...item,
    //       status: "Pending", // Change 'Pending' to the actual status value
    //     };
    //   });
    // },


    getVehicle() {
      const make = this.vehicleId.make;
      return make;
    },

    getDriver() {
      const driver = this.usersId.firstName;
      return driver;
    },

    formattedDeliveryDate: {
      get() {
        return formatDate(this.deliveryDate);
      },
      set(value) {
        this.deliveryDate = this.parseDate(value);
      }
    }
  },
  methods: {
    clearFilters() {
      // Reset the filters object
      this.filters = {
        invoiceNo: '',
        itemId: '',
        note: '',
        quantity: ''
      };
      this.$forceUpdate(); // Triggers a reactive update in Vue if necessary
    },
    ...mapActions("distributionModule", ["getVehicleListAction"]),
    
    ...mapActions("deliveriesModule", ["getDeliveryByIDAction", "updateDeliveryAction",
     "deleteDeliveryItemAction", "getDeliveryItemListAction", "addDeliveryItemAction",
      "updateDeliveryItemAction", "updateDeliveryItemStatusAction"]),

    ...mapActions("vehicleModule", ["getVehicleByIDAction"]),
    ...mapActions("userModule", ["getUserIdAction", "getUserListAction"]),
    ...mapActions("productModule", ["getProductListAction"]),
    //...mapActions("invoiceModule", ["getInvoicesListAction", "getInvoiceIdAction"]),
    ...mapActions("salesPersonModule", ["getSalesPersonListAction"]),
    ...mapActions("deliveryModule", ["getAllDeliveryNoteListAction"]),

    additionalFieldChanges(customFields) {
      this.deliveryid.additionalFields = customFields;
    },

    confirmDeleteDelivery(deliveryitem) {
      //console.log("itemssssssssss", deliveryitem);
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then((result) => {
        this.deleteDeliveryitem(deliveryitem);
        if (result.value) {
          this.deleteDeliveryitem(deliveryitem);
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire({
            title: 'Cancelled',
            text: 'Your delivery is safe :)',
            icon: 'error',
            customClass: {
              confirmButton: 'btn btn-success',
            },
          });
        }
      });
    },

    deleteDeliveryitem(deliveryitem) {
      //console.log("itemssssssssss2222222", deliveryitem);
      const index = this.deliveryItems.findIndex((d) => d.id === deliveryitem.id);
      //console.log("index", index);
      // if (index === -1) {
      //   this.deliveryItems.splice(index, 1);
       this.deleteDeliveryItemAction(deliveryitem.id);
        Swal.fire({
          title: 'Deleted!',
          text: 'The delivery item has been deleted.',
          icon: 'success',
          customClass: {
            confirmButton: 'btn btn-success',
          },
        });
      //}
    },

    successAdd() {
      this.$swal({
        title: "Delivery Updated!",
        text: "You have successfully updated an Delivery!",
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },

    
    successItemUpdate() {
      this.$swal({
        title: "Delivery Item Updated!",
        text: "You have successfully updated the delivery item status!",
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    // error
    errorAdd() {
      this.$swal({
        title: "Error!",
        text: " Failed!",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    SubmitDelivery() {
      let payload = {
        id: this.id,
        vehicleID: this.deliveryid.vehicleID,
        driverID: this.deliveryid.driverID,
        pickUpLocation: this.deliveryid.pickUpLocation,
        dropOffLocation: this.deliveryid.dropOffLocation,
        deliveryDate: this.deliveryid.deliveryDate,
        deliveryStatus: this.deliveryid.deliveryStatus,
        note: this.deliveryid.note,
        additionalFields: this.deliveryid.additionalFields
      };
      this.updateDeliveryAction(payload)
        .then(() => {
          this.successAdd();
          // clearDeliveryForm();
          //window.location.href = '/views/delivery/Deliveries.vue';
          const selectedItems = this.deliveryItems.filter(item => item.selected);
          const itemDetailPromises = selectedItems.map(item => {
            let payload2 = {
              deliveryID: payload.id, // Corrected the reference to payload.id
              deliveryNoteID: item.id, // Assuming item.id is the correct ID for selected items
              productID: item.itemId, // Adjust this if itemId is nested differently
              quantity: 0,
              status: "INTRANSIT",
              specialInstructions: ""
            };

            return this.addDeliveryItemAction(payload2);
          });

          return Promise.all(itemDetailPromises);

        })
        .then(itemDetails => {
          // This now contains the list of payload2 objects that were created in the previous step
          const itemStatusPromises = itemDetails.map(detail => {
            let payload3 = {
              id: detail.id,
              status: detail.status
            };

            return this.updateDeliveryItemStatusAction(payload3);
          });

          return Promise.all(itemStatusPromises);
        })
        .then(() => {
          // Final success handling
          this.successAdd();
          this.$router.push({ name: "deliveries" });
        })
        .catch(error => {
          // Error handling
          this.errorAdd();
          this.clearDeliveryForm();
          console.error(error);
        });
    },
    clearDeliveryForm() {
      this.delivery.vehicleId = "";
      this.delivery.driverId = "";
      this.delivery.pickUpLocation = "";
      this.delivery.dropOffLocation = "";
      this.delivery.deliveryDate = "";
      this.delivery.deliveryStatus = "";
      this.delivery.notes = "";
    },

    toggleModal() {
      this.modalOpen = !this.modalOpen;
    },
    getProductName(id) {
      const prod = this.products.find((s) => s.id === id);
      return prod ? prod.name : "-";
    },
    saveChanges() {
      // Save changes and close the modal
      const selected = this.deliveryItems.filter(item => item.selected);
      //this.selectedItems = selected;
      //this.$store.dispatch('addDeliveryItemAction', selected);
      this.modalOpen = false;

    },
    editField(item, field) {
      this.$set(item, field, true);
    },
    saveField(item, field) {
      this.$set(item, field, false);

      let payload = {
        id: item.id,
        deliveryID: item.deliveryID,
        deliveryNoteID: item.deliveryNoteID,
        productID: item.productID,
        quantity: item.deliveryNote.quantity,
        status: item.status
      };
      //console.log("payloadquant", payload);
      this.updateDeliveryItemAction(payload)
        .then(() => {
          this.successItemUpdate();
        })
        .catch(error => {
          // Error handling
          this.errorAdd();
          console.error(error);
        });


    },

    getStatusColor(status) {
      switch (status) {
        case "PENDING":
          return "warning";
        case "INTRANSIT":
          return "info";
        case "DELIVERED":
          return "success";
        case "CANCELLED":
          return "info";
        default:
          return "secondary";
      }
    },

    parseDate(date) {
      if (!date) return '';
      const [day, month, year] = date.split('/');
      return `${year}-${month}-${day}`;
    }
  },
  async mounted() {
    // this.selectedItems.forEach(item => {
    //     item.selected = false;
    // });
    
    await this.getVehicleListAction().then(() => {
      this.vehicles.map((v, i) =>
        this.vehicleOptions.push({
          value: v.vehicleId,
          text: v.make,
        })
      );
    });

    await this.getUserListAction().then(() => {
        this.users.map((v, i) =>
          this.driverOptions.push({
            value: v.id,
            text: `${v.firstName} ${v.lastName || ''}`,
            item: v,
          })
        );
      });

    await this.getDeliveryByIDAction(this.id);
    // .then(() => {
    //   this.deliveryid.map((v, i) =>
    //     this.deliveryStatusOptions.push({
    //       value: v.id,
    //       text: v.deliveryStatus,
    //     })
    //   );
    // });

    console.log("selectedddddddddddddd", this.selectedItemsWithStatus);

    await this.getVehicleByIDAction(this.deliveryid.vehicleID);
    await this.getUserIdAction(this.deliveryid.driverID);

    //await this.getInvoiceIdAction(this.invoiceId);
    await this.getAllDeliveryNoteListAction();
    await this.getProductListAction(true);
    await this.getDeliveryItemListAction(this.id);
  },
};
</script>

<style scoped>
/* Add your existing styles here */
</style>